import type { ReactNode } from 'react'
import { CheckCircle2 } from 'lucide-react'
import { useEffect, useRef } from 'react'
import { cn } from '~/lib/utils'

type Props = {
  title: string
  /** Vert quand le contenu est terminé, neutre sinon. */
  success: boolean
  children: ReactNode
}

/**
 * Ce que le lecteur montre quand le contenu rend la main : un titre et les
 * suites possibles (#26, #160). Plus de redirection automatique (RGAA 13.1) ;
 * le cadre qui avait le focus disparaît, le focus va au titre, qui est ainsi lu (7.5).
 */
function FinishedScreen({ title, success, children }: Props) {
  const heading = useRef<HTMLHeadingElement>(null)
  useEffect(() => heading.current?.focus(), [])

  return (
    <div className="flex h-full items-center justify-center bg-background px-6">
      <div className="flex max-w-sm flex-col items-center gap-4 text-center">
        <div className={cn('flex size-16 items-center justify-center rounded-full', success ? 'bg-green-500/10' : 'bg-muted')}>
          <CheckCircle2 className={cn('size-9', success ? 'text-success-text' : 'text-muted-foreground')} />
        </div>
        <h2 ref={heading} tabIndex={-1} className="font-heading text-2xl text-balance focus:outline-none">{title}</h2>
        {children}
      </div>
    </div>
  )
}

export default FinishedScreen
